import {
    SELECTED_STATION,
    CLEAR_STATION_SELECTION,
    SELECTED_NOTES,
    RECEIVED_NOTES,
    CATEGORIES_FETCHED,
    LAST_VISIT_INFO,
    FETCHING_DATA,
    CHECK_IN
} from '../../actions/types';

let defaultState = {
    selectedStationId: 0,
    selectedNotesIds: [],
    categories: [],
    notes: false,
    didCheckedIn: false,
    fetchingData: false,
    lastVisitInfo: false
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case SELECTED_NOTES:
            return {...state, selectedNotesIds: action.payload};
        case FETCHING_DATA:
            return {...state, fetchingData: true};
        case RECEIVED_NOTES:
            return {...state, notes: action.payload, fetchingData: false};
        case CATEGORIES_FETCHED:
            return {...state, categories: action.payload};
        case LAST_VISIT_INFO:
            return {...state, lastVisitInfo: action.payload};
        case CHECK_IN:
            return {...state, didCheckedIn: action.payload};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Visits/index.js